{
  "name": "eligibility-portal",
  "version": "1.10.1",
  "scripts": {
    "test": "jest",
    "lint": "run-p lint:*",
    "lint:typecheck": "tsc --noEmit",
    "lint:eslint": "eslint src",
    "lint:prettier": "prettier -c .",
    "lint:stylelint": "stylelint 'src/**/*.css'",
    "start": "COMMIT_SHA=\"$(git rev-parse --short HEAD)\" BUILD_NUMBER=local ENVIRONMENT=dev parcel src/index.html --open",
    "build": "COMMIT_SHA=\"$(git rev-parse --short HEAD)\" parcel build src/index.html",
    "generate-members": "./generate-members.ts",
    "generate-member-groups": "./src/scripts/generate-member-groups.ts"
  },
  "repository": {
    "type": "git",
    "url": "git+ssh://git@gitlab.com/garner-health/ui-eligibility-portal.git"
  },
  "prettier": "@garner-health/prettier-config",
  "license": "UNLICENSED",
  "bugs": {
    "url": "https://gitlab.com/garner-health/ui-eligibility-portal/issues"
  },
  "homepage": "https://gitlab.com/garner-health/ui-eligibility-portal#readme",
  "alias": {
    "@garner-health/logging": "@garner-health/logging/dist/esm/index-browser.js",
    "joi": "joi/lib/index.js",
    "util": "util/util.js",
    "crypto": "crypto-js",
    "app-constants": {
      "global": "appConstants"
    }
  },
  "parcelIgnore": [
    "ui/constants.js"
  ],
  "devDependencies": {
    "@babel/cli": "^7.5.5",
    "@babel/preset-env": "^7.5.5",
    "@faker-js/faker": "^7.3.0",
    "@garner-health/api-client": "^12.272.0",
    "@garner-health/eslint-config": "^1.3.1",
    "@garner-health/prettier-config": "^1.1.0",
    "@parcel/transformer-svg-react": "^2.7.0",
    "@types/papaparse": "^5.3.7",
    "@types/react": "^17.0.48",
    "@types/react-dom": "^17.0.17",
    "@types/uuid": "^8.3.4",
    "dotenv": "^16.0.3",
    "eslint": "^8.25.0",
    "isomorphic-fetch": "^3.0.0",
    "jest": "^28.1.3",
    "jest-joi": "^1.1.12",
    "npm-run-all": "^4.1.5",
    "parcel": "^2.6.2",
    "parcel-namer-custom": "./parcel-namer-custom",
    "parcel-reporter-copy-constants": "./parcel-reporter-copy-constants",
    "parcel-resolver-ignore": "^2.1.3",
    "parcel-transformer-set-globals": "./parcel-transformer-set-globals",
    "prettier": "^2.7.1",
    "stylelint": "^14.13.0",
    "stylelint-config-recommended": "^9.0.0",
    "stylelint-prettier": "^2.0.0",
    "ts-jest": "^28.0.8",
    "ts-node": "^10.9.1",
    "typescript": "^4.7.4"
  },
  "dependencies": {
    "@aws-amplify/ui-react": "^3.3.0",
    "@garner-health/logging": "^4.5.2",
    "@types/jest": "^28.1.8",
    "aws-amplify": "^4.3.29",
    "crypto-js": "^4.1.1",
    "date-fns": "^2.29.2",
    "evergreen-ui": "^6.10.3",
    "immutability-helper": "^3.1.1",
    "joi": "^17.6.0",
    "launchdarkly-react-client-sdk": "^3.0.8",
    "os-browserify": "^0.3.0",
    "papaparse": "^5.3.2",
    "process": "^0.11.10",
    "querystring-es3": "^0.2.1",
    "react-dom": "^17.0.2",
    "react-error-boundary": "^4.0.11",
    "react-icons": "^4.4.0",
    "react-transition-group": "^4.4.5",
    "util": "^0.12.4",
    "uuid": "^8.3.2"
  }
}
